import React from 'react';
import styles from './TableFooter.module.scss';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';

type TableFooterProps = {
    page: number;
    totalPages: number;
    rangeLabel: string;
    bordered?: boolean;
    onPageChange: (page: number) => void;
    className?: string;
};

const SLOTS = 7;

const buildPages = (page: number, totalPages: number): (number | 'gap')[] => {
    if (totalPages <= SLOTS) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    if (page <= 4) {
        return [1, 2, 3, 4, 5, 'gap', totalPages];
    }

    if (page >= totalPages - 3) {
        return [
            1,
            'gap',
            totalPages - 4,
            totalPages - 3,
            totalPages - 2,
            totalPages - 1,
            totalPages,
        ];
    }

    return [1, 'gap', page - 1, page, page + 1, 'gap', totalPages];
};

export function TableFooter({
    page,
    totalPages,
    rangeLabel,
    bordered = true,
    onPageChange,
    className,
}: TableFooterProps) {
    return (
        <div className={cx(styles.foot, !bordered && styles.noBorder, className)}>
            <div className={styles.total}>
                Показано <b>{rangeLabel}</b>
            </div>

            {totalPages > 1 && (
                <nav className={styles.pager} aria-label="Страницы">
                    <button
                        type="button"
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        aria-label="Предыдущая страница"
                    >
                        <ChevronLeftIcon />
                    </button>

                    {buildPages(page, totalPages).map((item, index) =>
                        item === 'gap' ? (
                            <span key={`gap-${index}`} className={styles.ell}>…</span>
                        ) : (
                            <button
                                key={item}
                                type="button"
                                className={cx(item === page && styles.active)}
                                aria-current={item === page ? 'page' : undefined}
                                onClick={() => onPageChange(item)}
                            >
                                {item}
                            </button>
                        ),
                    )}

                    <button
                        type="button"
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        aria-label="Следующая страница"
                    >
                        <ChevronRightIcon />
                    </button>
                </nav>
            )}
        </div>
    );
}